import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { LoginService } from "../login.service";
import account from '@mixin/account';
var loginService = new LoginService();
export default {
  data: function data() {
    return {
      userInfo: {
        phone: '',
        verifyCode: ''
      },
      showTime: false,
      // 验证码显示
      time: 90
    };
  },
  computed: {
    // 是否禁用登录按钮
    isDisabled: function isDisabled() {
      return !this.userInfo.phone && !this.userInfo.verifyCode;
    }
  },
  mixins: [account],
  mounted: function mounted() {
    this.targetCustomerLogin();
  },
  methods: {
    // 立即注册页面显示隐藏
    loginIndexShow: function loginIndexShow() {
      this.$emit('change');
    },
    // 手机号验证
    getVerifyCode: function getVerifyCode() {
      var _this = this;
      if (!this.userInfo.phone) {
        this.$messageTip('请输入手机号！', 'error');
        return;
      }
      var res = /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
      if (!res.test(this.userInfo.phone)) {
        this.$messageTip('手机号码有误！', 'error');
        return;
      }
      var url = "/pjyy-deepexi-user-center/api/v1/common/toLogin/sendVerifyCode?phone=".concat(this.userInfo.phone);
      this.$getHttpClient().post(url).then(function (res) {
        if (res.data.code == '200') {
          _this.showTime = true;
          //倒计时
          var that = _this;
          var timer = setInterval(function () {
            that.time--;
            if (that.time == 0) {
              clearInterval(timer);
              that.time = 90;
              _this.showTime = false;
            }
          }, 1000);
        } else {
          _this.$messageTip(res.data.msg, 'error');
        }
      });
    },
    onLogin: function onLogin() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                account: _this2.userInfo.phone,
                loginSource: "PC",
                loginSystem: "MALL",
                loginType: "VERIFY",
                verifyCode: _this2.userInfo.verifyCode
              };
              _context.next = 3;
              return loginService.siginIn(params);
            case 3:
              result = _context.sent;
              if (result.code === "200") {
                // 如果登录客户是目标客户
                if (result.data.whetherToLogInWithYourPhone) {
                  localStorage.setItem('currentLoggedInPhoneNumber', _this2.userInfo.phone);
                }
                _this2.$messageTip('登录成功', 'success');
                _this2.$router.push({
                  name: 'v2-home'
                });
              } else {
                _this2.$messageTip(result.msg, 'error');
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};